import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { screeningAction } from '../../actions/constant';
import screeningService from '../../../services/apiServices/screeningDetails/screeningDetails';
const { GET_SCREENING_TYPE_REQUEST,
    GET_SCREENING_TYPE_SUCCESS,
    GET_SCREENING_TYPE_FAILURE } = screeningAction;

function* getScreeningType(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(screeningService.getScreeningType, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_SCREENING_TYPE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_SCREENING_TYPE_FAILURE, payload: error });
  }
}

function* getScreeningTypeSaga() {
  yield takeEvery(GET_SCREENING_TYPE_REQUEST, getScreeningType);
}

export default getScreeningTypeSaga;
